<script lang="ts">
  import { page } from '$app/stores';

  import { truncateString } from '@shared/utils';

  import { MAX_BREADCRUMB_LENGTH as maxBreadcrumbLength } from '../configs';

  export let classes = '';

  $: breadCrumbs = $page.data?.seo?.breadcrumbs || [];
</script>

{#if breadCrumbs?.length > 0}
  <div class="{classes}">
    <nav aria-label="Breadcrumb" class="hidden max-w-full lg:block">
      <ul class="lg:flex lg:w-full lg:justify-start">
        {#each breadCrumbs as breadCrumb, index}
          {@const shortName = truncateString(breadCrumb.name, maxBreadcrumbLength)}
          {@const slugWithSlash = breadCrumb.slug.endsWith('/') ? breadCrumb.slug : `${breadCrumb.slug}/`}

          <li>
            {#if $page.url.pathname === slugWithSlash}
              <span class="lg:text-default-400 lg:cursor-default lg:text-xs" title="{breadCrumb.name}">
                {shortName}
              </span>
            {:else}
              <a
                class="lg:text-default-500 lg:hover:text-default-500 lg:dark:hover:text-default-400 lg:text-xs lg:transition-colors"
                href="{slugWithSlash}"
                title="{breadCrumb.name}"
              >
                {shortName}
              </a>
            {/if}

            {#if index !== breadCrumbs.length - 1}
              <span class="lg:text-default-500 lg:dark:text-dark-600 lg:mx-2 lg:text-xs">/</span>
            {/if}
          </li>
        {/each}
      </ul>
    </nav>
  </div>
{/if}
